// The totals row under the department × status grid: each column's sum across
// the departments shown, and the sum of those.
export const columnTotals = (rows, stages) => {
  const totals = stages.map((stage) => ({
    key: stage.key,
    count: (rows || []).reduce((n, row) => n + (row.stages.find((c) => c.key === stage.key)?.count ?? 0), 0),
  }));
  return { totals, grandTotal: totals.reduce((n, t) => n + t.count, 0) };
};
